import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_4: FaireProductEntity = {
  token: "nyc-bev-4",
  type: "product",
  name: "Organic Herbal Tea Blend",
  brandName: "Hudson Valley Tea Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/142551a0d6d9e44fd24a58838915073cb81081076b529cd4eff018f5dbb48f4a.webp",
  priceDollars: 9,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/142551a0d6d9e44fd24a58838915073cb81081076b529cd4eff018f5dbb48f4a.webp",
  weight: 1,
  dimensions: {
    width: 3,
    height: 8,
    depth: 3,
  },
  description: "Handcrafted kombucha from Queens",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "organic", "probiotic"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
